import { NgIf } from '@angular/common';
import {
  Component,
  Input,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  inject,
} from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { ActivatedRoute, Router, RouterOutlet } from '@angular/router';
import { MediaWatcherService } from '../../../../services/media-watcher/media-watcher.service';
import {
  ZopLoadingBarComponent,
  ZopFullscreenComponent,
  ZopVerticalNavigationComponent,
  ZopNavigationService,
  NotificationsComponent,
  ShortcutsComponent,
  ZopBrandingService,
} from '@zopup/zop-ux-core';
import { Subject, takeUntil } from 'rxjs';
import { LanguagesComponent } from '../../../common/languages/languages.component';
import { MenuType } from '../../../../services/navigation/menu-type.types';
import { NavigationService } from '../../../../services/navigation/navigation.service';
import { ZopUxLayoutLibConfig } from '../../../../services/config/config.types';
@Component({
    selector: 'zop-compact-layout',
    templateUrl: './compact.component.html',
    encapsulation: ViewEncapsulation.None,
    imports: [
        ZopLoadingBarComponent,
        MatButtonModule,
        MatIconModule,
        LanguagesComponent,
        ZopFullscreenComponent,
        ShortcutsComponent,
        NotificationsComponent,
        NgIf,
        RouterOutlet,
        ZopVerticalNavigationComponent,
    ]
})
export class CompactLayoutComponent implements OnInit, OnDestroy {
  isScreenSmall: boolean;
  navigation: MenuType;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  @Input()
  config: ZopUxLayoutLibConfig;
  readonly branding: ZopBrandingService = inject(ZopBrandingService);
  /**
   * Constructor
   */
  constructor(
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _navigationService: NavigationService,
    private _zopMediaWatcherService: MediaWatcherService,
    private _zopNavigationService: ZopNavigationService
  ) {}

  // -----------------------------------------------------------------------------------------------------
  // @ Accessors
  // -----------------------------------------------------------------------------------------------------

  /**
   * Getter for current year
   */
  get currentYear(): number {
    return new Date().getFullYear();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    // Subscribe to navigation data
    this._navigationService.navigation$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((navigation: MenuType) => {
        this.navigation = navigation;
      });

    // Subscribe to media changes
    this._zopMediaWatcherService.onMediaChange$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe(({ matchingAliases }) => {
        // Check if the screen is small
        this.isScreenSmall = !matchingAliases.includes('md');
      });
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Public methods
  // -----------------------------------------------------------------------------------------------------

  /**
   * Toggle navigation
   *
   * @param name
   */
  toggleNavigation(name: string): void {
    // Get the navigation
    const navigation =
      this._zopNavigationService.getComponent<ZopVerticalNavigationComponent>(
        name
      );

    if (navigation) {
      // Toggle the opened status
      navigation.toggle();
    }
  }
}
